import React from 'react';
import { useTranslation } from '@dukanti/shared';
import { Search } from 'lucide-react';

export interface OrdersSearchInputProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder: string;
}

export function OrdersSearchInput({
  value,
  onChange,
  placeholder,
}: OrdersSearchInputProps): React.JSX.Element {
  const { dir } = useTranslation();
  const [localValue, setLocalValue] = React.useState(value);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChange(localValue);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [localValue, value, onChange]);

  return (
    <div dir={dir} className="relative w-full max-w-md flex-1">
      <Search
        className="text-muted-foreground absolute start-3 top-1/2 -translate-y-1/2"
        size={18}
        strokeWidth={2}
        aria-hidden="true"
      />
      <input
        data-testid="orders-search-input"
        type="text"
        aria-label={placeholder}
        placeholder={placeholder}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className="border-input bg-background text-foreground placeholder:text-muted-foreground focus:border-admin-lime focus:ring-admin-lime/20 w-full rounded-lg border py-2.5 pe-4 ps-10 text-sm transition-all focus:outline-none focus:ring-2"
      />
    </div>
  );
}
